import styled from 'styled-components';
import { BORDERS } from 'variables/theme';

export const InnerWrapper = styled.div`
  border-top: ${BORDERS.generic};
  margin-top: 1rem;
  padding-top: 3rem;
`;
